// extracted by mini-css-extract-plugin
export default {"imageContainer":"VideoSection_imageContainer__W+Q3k","coverImage":"VideoSection_coverImage__GNZmO","showImageButton":"VideoSection_showImageButton__SSfLN"};